module.exports = __webpack_public_path__ + "assets/745be75d538a714652eedaae2b9927c6.mp4";